import React from 'react';
import InputWrapper from '../Wrappers/InputWrapper';
import withFormValidations from 'react-validator';
import { Events } from 'ui-utilities';
import { PasswordStrength } from 'ui-components';

class SignUp extends React.Component {
  componentDidMount() {
    this.props.onChange(this.props.field('email'), this.props.email);
    setTimeout(() => document.getElementsByTagName('input')[3].focus(), 100);

    Events
      .provide('kissmetrics', true)
      .log(
        'record', 
        'Merchant Sign-up Form View'
      );
  }

  isValid() {
    return this.props.inputs.filter(i => {
      return i.validations.errors.length < 1 && i.validations.val !== '';
    }).length === this.props.inputs.length;
  }

  reset = e => {
    e.preventDefault();
    this.props._auth.resetLogin();
    this.props.registeredUser(true);
  }

  _submit = e => {
    e.preventDefault();
    if (this.props.valid()) {
      this.props._auth.signUp(this.props.inputs)
        .then(res => !res.error && this.props._auth.toggleAuthenticationModal());
    }
  }

  render() {
    const { auth, field } = this.props;

    const email = field('email');
    const password = field('password');
    const confirmPassword = field('confirmPassword');
    const name = field('name');
    const zip = field('zip');

    return <div>
        <h3>Let's create your account</h3>
        <p className="fine-print">
          <span className="required">All fields required, please.</span> <em>Already have an account?</em> <a style={{ fontSize: '1em', textDecoration: 'underline' }} onClick={this.reset}>Sign in</a>
        </p>
        <form name="signin">
          <div className="form-group">
            <label htmlFor="email">Your email</label>
            {email &&
              <InputWrapper {...this.props}
                input={email}
                onChange={this.props.onChange}
                valid={this.props.valid}
                type="email" />}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            {password &&
              <InputWrapper {...this.props}
                input={password}
                onChange={this.props.onChange}
                valid={this.props.valid}
                type="password" />}
            <div className="mt-2">
              <PasswordStrength password={password.validations.val} />
            </div>
            <div className="fine-print"
              style={{ marginTop: '10px' }}>
              Reminder: Passwords must incorporate some combination of numbers, upper case letters, symbols or phrases.
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            {confirmPassword &&
              <InputWrapper {...this.props}
                input={confirmPassword}
                onChange={this.props.onChange}
                valid={this.props.valid}
                type="password" />}
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="name">First Name</label>
                <InputWrapper {...this.props}
                  input={name}
                  onChange={this.props.onChange}
                  valid={this.props.valid} />
              </div>
              <div className="col-md-6">
                <label htmlFor="name">Home Zip Code</label>
                <InputWrapper {...this.props}
                  input={zip}
                  onChange={this.props.onChange}
                  valid={this.props.valid} />
              </div>
            </div>
            <div className="fine-print"
              style={{ marginTop: '10px' }}>
              We're all about harnessing the power of local knowledge. We need your zip code to know where you call home!
            </div>
          </div>

          {auth.get('errors').size > 0 && <ul style={{ marginBottom: '20px' }}>
            {auth.get('errors').map((e, i) => <li key={i} className="error">
              <i className="fa fa-exclamation-circle"></i>
              {e.get('detail')}
            </li>)}
          </ul>}

          <div className="form-action">
            <button className={this.isValid() && "valid"} onClick={this._submit}>Save and Continue <i className="fa fa-angle-right"></i></button>
          </div>
        </form>
      </div>;
  }
}

export default withFormValidations(SignUp, [{
    label: 'email',
    rules: [{
      rule: 'email',
      message: 'Invalid email address'
    }, {
      rule: 'required',
      message: 'An email address is required'
    }]
  }, {
    label: 'password',
    rules: [{
      rule: 'required',
      message: 'A password is required'
    }, {
      rule: 'strength',
      message: 'That password is not strong enough. Please consider using numbers, upper case letters or phrases.'
    }, {
      rule: 'max',
      args: 6,
      message: 'Password needs to be 6 or more characters'
    }]
  }, {
    label: 'confirmPassword',
    rules: [{
      rule: 'required',
      message: 'A password is required'
    }, {
      rule: 'match',
      args: 'password',
      message: 'Password mismatch'
    }]
  }, {
    label: 'name',
    rules: [{
      rule: 'required',
      message: 'A first name is required'
    }]
  }, {
    label: 'zip',
    rules: [{
      rule: 'required',
      message: 'A home zip code is required'
    }]
  }]);



// WEBPACK FOOTER //
// ./src/components/User/SignUp.js